import { useForm } from "react-hook-form";
import { Buttons } from "../../../components/button/Button";
import { InputField } from "../../../components/input/InputFields";
import { Event } from "../EventTypes";
import { useState } from "react";

type EventTicketFormValues = {
    amount: number;
}

interface EventTicketFormProps {
    onComplete: (amount: number) => void;
    event: Event;
}

function computePrice(amount: number, price: number): number {
    return price * amount;
}

export default function EventTicketForm(props: EventTicketFormProps) {

    const [totalPrice, setTotalPrice] = useState<string>(props.event.price.toFixed(2));

    const { register, formState: { errors }, handleSubmit } = useForm<EventTicketFormValues>({
        defaultValues: {
            amount: 1
        }
    });

    return <>
        <form onSubmit={handleSubmit((values) => props.onComplete(values.amount))}>
            <InputField
                label="Anzahl der Tickets"
                register={register("amount", {
                    min: { value: 1, message: "Bitte gib mindestens ein Ticket an" },
                    max: { value: props.event.remainingSpots, message: `Aktuell können maximal ${props.event.remainingSpots} Tickets gebucht werden.` }
                })}
                type={'number'}
                name='amount'
                hasError={Boolean(errors?.amount)}
                errorMessage={errors.amount?.message}
                onChange={(e) => {
                    if (e.currentTarget.value) {
                        setTotalPrice(computePrice(Number.parseInt(e.currentTarget.value), props.event.price).toFixed(2))
                    }
                }
                }
            />
            <div className="priceIndicatorAndButtonWrapper">
                <span>Aktueller Buchungsbetrag: <strong>{totalPrice} €</strong></span>
                <Buttons submitButtonText="Weiter" />
            </div>
        </form >
    </>
}